export default {
  'register.fullName': 'Họ và tên',
  'register.button.account': 'Đăng ký',
};
